import { yaTag } from '../../middleware/yandex/yandex.tag';

document.addEventListener('DOMContentLoaded', () => {
  const CART_ADD_URI = '/v1/cart/add';

  $(document).on('click', 'button.event-add-to-cart', async (e) => {
    const button = $(e.currentTarget).parent('.btn-buy');
    const productId = button.find('button.event-add-to-cart').data('product-id');

    const buttons = $(`button.event-add-to-cart[data-product-id=${productId}] `);

    buttons.each((_, element) => {
      element = $(element).parent('.btn-buy');
      element.prop('disabled', true);
      element.addClass('loader');
    });

    /**
     * @type {{
     *   productId: Number;
     *   count: Number;
     *   pageInfo: String;
     *   countAdditionalKeys: any | Window.jQuery | number;
     * }}
     */
    const data = {
      productId,
      count: 1,
    };

    window.promiseQueue.add('change-cart', () => {
      window.axios
        .post(CART_ADD_URI, data)
        .then((response) => {
          response.data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
          document.updateCartIcon(response.data?.cartItemCount);

          const event = document.createEvent('Event');
          event.initEvent('Cart:add', true, true);

          buttons.each((_, element) => {
            element = $(element).parent('.btn-buy');
            element.removeClass('loader');
            element.addClass('btn-sold');
            element[0].dispatchEvent(event);
          });
        })
        .catch((error) => {
          buttons.each((_, element) => {
            element = $(element).parent('.btn-buy');
            element.removeClass('loader');
          });
          document.modalMessageErrorShow();
          // eslint-disable-next-line no-console
          console.warn(error);
        });
    });
  });
});
